// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + {"12":"profiler","8819":"bc0902ee","9777":"recorder"}[chunkId] + "." + {"12":"3031de423984d1eb","8819":"4a976c1bfbfd1c90","9777":"cb643881b7ab080e"}[chunkId] + ".js";
};